/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  query LBRRouteReadQuery($type: CUSTOMER_TYPE!, $take: PositiveInt, $skip: Int, $search: String, $filter: JSONObject) {
    LBRRouteRead(type: $type, take: $take, skip: $skip, search: $search, filter: $filter) {
      id,
      createdAt,
      updatedAt,
      displayName,
      type,
      message,
      status,
      _totalCount,
      Account {
        id
        email
        displayName
      }
      LBRRoutePlan {
        id,
        Mcc {
          mcc
        },
        Mnc {
          mnc,
          network
        }
      }
    }
  }
`
